import React, { useContext } from "react";
import { Link } from "react-router-dom";
import cubaimg from "../../assets/images/logo/Murasal_One_Icon_Transparent.png";
import CustomizerContext from "../../_helper/Customizer";

const SidebarIcon = () => {
  const { layoutURL } = useContext(CustomizerContext);

  return (
    <div className="logo-icon-wrapper">
      <Link to={`${process.env.PUBLIC_URL}/dashboard/${layoutURL}`}>
        <img
          className="img-fluid"
          src={cubaimg}
          alt=""
          style={{
            width: "45px",
            height: "45px",
            objectFit: "contain",
          }}
        />
      </Link>
    </div>
  );
};

export default SidebarIcon;
